<template>
<div id="toolsViewerComponent" class="container-fluid">
  <slideout-panel></slideout-panel>
  <div class="row" id="toolbar">
    <h5> Carte N° {{ this.mapList[index].mapIdentifier }}
      <span id="mapTitleSpan"> &nbsp; : &nbsp; {{ this.mapList[index].mapTitle }} &nbsp; </span>
    </h5>
    <span id="contextualizedTitleSpan"> &nbsp; - &nbsp; ({{ this.mapList[index].contextualizedTitle }}) &nbsp;&nbsp;&nbsp; </span>
    <span class="spacer"></span>
    <div id="tools">
      <b-button-group size="sm">
        <b-button v-if="hasInventries" :pressed="!isModeActivated" v-b-tooltip title="Carte brute" variant="dark" @click="hideInventoryEntries()">
          <img src="../../assets/logos/france24x24.png"  alt="Fr"  class="img-fluid" />
        </b-button>
        <b-button v-if="!hasInventries && isAuthenticated" :pressed="$parent.showInventryGeneratorSideBar" v-b-tooltip title="Créer points" variant="dark" @click="showInventryGeneratorSideBar()">
            <img src="../../assets/logos/genratePoints_24x24.png"  alt="Annotations"  class="img-fluid" />
        </b-button>
        <b-button v-b-tooltip title="Annotations" :pressed="isModeActivated" variant="dark" @click="showInventoryEntries('interpretations')" 
        v-if="hasInventries && !missPhoneticTranscriptions && mode != 'phoneticTranscription'">
          <img src="../../assets/logos/annotation_24x24.png"  alt="Annotations"  class="img-fluid" />
        </b-button>
        <b-button v-b-tooltip title="Transcriptions phonétiques" :pressed="isModeActivated && mode != 'interpretations'" variant="dark" @click="showInventoryEntries('phoneticTranscription')"
        v-if="hasInventries && !hasInterpretations && mode != 'interpretations'">
        <img src="../../assets/logos/transpPhonetique_24x24.png"  alt="TP"  class="img-fluid" />
        </b-button>
        <b-button v-b-tooltip title="Afficher les commentaires de carte" :pressed="$parent.showMapCommentSideBar" variant="dark" @click="showOrHideMapCommentSideBar()">
          <mapCommentIcon id="icons"></mapCommentIcon>
        </b-button>
        <b-dropdown variant="dark" toggle-class="text-decoration-none" v-b-tooltip title="Ressources Europeana">
          <template v-slot:button-content>
             <img src="../../assets/logos/logoEuropeana_24x24.png"  alt="Annotations"  class="img-fluid" />
          </template>
          <b-dropdown-item @click="showEuropeanaPanel(true)">Rechercher sur Europeana</b-dropdown-item>
          <b-dropdown-item @click="showEuropeanaPanel(false)">Consulter les ressources enregistrées</b-dropdown-item>
        </b-dropdown>

        <b-dropdown v-if="hasInventries" variant="dark" toggle-class="text-decoration-none" v-b-tooltip title="Exporter les données">
          <template v-slot:button-content>
           <img src="../../assets/logos/exportCSV_24x24.png"  alt="Export CSV"  class="img-fluid" />
          </template>
          <b-dropdown-item @click="exportPhoneticTranscription()">Exporter les transcriptions phonétiques</b-dropdown-item>
          <b-dropdown-item v-if="hasInventries && !missPhoneticTranscriptions" @click="exportInterpretations()">Exporter les interprétations</b-dropdown-item>
        </b-dropdown>

      </b-button-group>
    </div>
    <b-modal class="container" title="Clavier API" id="modal-2" hide-footer>
      <APIKeyboard></APIKeyboard>
    </b-modal>
    <span class="spacer"></span>
    <searchIcon></searchIcon>
    &nbsp;&nbsp;
    <b-form-input v-model="selectedMapOption" v-on:change="showMap()" id="searchInput" placeholder="Recherche rapide de carte" list="mapSelection"></b-form-input>
    <datalist id="mapSelection">
      <option v-for="map in mapList" :key="map.mapIdenfier">{{map['mapIdentifier']}} - {{map['mapTitle']}}</option>
    </datalist>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import searchIcon from '../icons/SearchIcon'
import mapCommentIcon from '../icons/MapCommentIcon'
import APIKeyboard from '@components/commons/APIKeyboard'
import EuropeanaResourcesForMap from '@components/commons/EuropeanaResourcesForMap'
import EuropeanaSearch from '@components/search/EuropeanaSearch'

import * as d3 from 'd3'

export default {
  name: 'tools-viewer',
  props: ['viewer'],
  components: { searchIcon, mapCommentIcon, APIKeyboard, EuropeanaResourcesForMap, EuropeanaSearch },
  data() {
    return {
      selectedMapOption: null
    }
  },
  created() { this.$store.dispatch('updateIndex', this.$store.getters.getIndex) },
  computed: {
    ...mapGetters({
      index: 'getIndex',
      isModeActivated: 'getIsModeActivated',
      isAuthenticated: 'getIsAuthenticated',
      mode: 'getMode',
      hasInventries: 'getHasInventries',
      missPhoneticTranscriptions: 'getMissPhoneticTranscriptions',
      hasInterpretations: 'getHasInterpretations',
      mapList: 'getMapList',
      getMapByIndex: 'getMapByIndex',
      overlay: 'getOverlay'
    })
  },
  methods: {
    // Met à jour l'index pour visualiser la carte correspondante dans le visualiseur
    showMap: function() {
      let mapIdentifier = this.selectedMapOption.split(' ')[0]
      // Vérfication existence de la carte dans le tableau
      if (this.mapList.indexOf(this.mapList.filter(map => map.mapIdentifier === mapIdentifier)[0]) >= 0) {
        this.$store.dispatch('updateIndex', this.mapList.indexOf(this.mapList.filter(map => map.mapIdentifier === mapIdentifier)[0]))
        this.viewer.goToPage(this.index)
        this.$store.dispatch('updateCurrentInventoryEntry', null)
      }
      this.selectedMapOption = ""
      if(this.isModeActivated) {
      this.$store.dispatch('updateCurrentInventoryEntry', null)
      this.hideInventoryEntries()
      }
      this.$parent.showMapCommentSideBar = false
      this.$parent.showMapCommentSideBar = false
    },
    hideInventoryEntries: function() {
      d3.selectAll('circle').remove();
      this.$store.commit('UPDATE_MODE', '')
      this.$store.commit('UPDATE_MODE_ACTIVATION', false)
    },
    // Affichage/masquage des entrées d'inventaires (disques D3) en fonction du mode renseigné en paramètre (interprétation ou transcription phonétique)
    showInventoryEntries: function(mode) {
      if(this.$parent.showMapCommentSideBar) {
        this.$parent.showMapCommentSideBar = false
      }
      if(mode === 'phoneticTranscription'){
        this.$store.dispatch('findAllInventoryEntries', this.mapList[this.index].mapId)
      }
      if(!this.isModeActivated) {
      this.$store.dispatch('getAllInventoryEntriesForD3', { mapId: this.mapList[this.index].mapId, mode: mode })
      this.$store.commit('UPDATE_MODE_ACTIVATION', true)
      }
    },
    // Affiche le panel permettant de réaliser des requêtes sur Europeana et d'afficher les résultats
    showEuropeanaPanel: function(search) {
      if(this.isModeActivated){
        this.$store.dispatch('closeSideBar', '')
        this.hideInventoryEntries()
      }
      this.$showPanel({
        component: search ? EuropeanaSearch : EuropeanaResourcesForMap,
        openOn: 'right',
        hideBg: false,
        width: '900px',
        props: { currentMap: this.getMapByIndex(this.index) }
      })
    },
  // Export des données interprétations pour la carte courante
  exportInterpretations() {
    return this.$store.dispatch('exportInterpretations', this.getMapByIndex(this.index).mapId)
  },
  exportPhoneticTranscription() {
    return this.$store.dispatch('exportPhoneticTranscription', this.getMapByIndex(this.index).mapId)
  },
  // Affiche le composant de commentaires de cartes (émission de l'évènement au composant parent - SeadragonViewer)
  showOrHideMapCommentSideBar: function() {
    if(this.isModeActivated){
      this.$store.dispatch('closeSideBar', '')
      this.hideInventoryEntries()
    }
    if(this.$parent.showInventryGeneratorSideBar) {
      this.$store.dispatch('resetInventryGenerator')
      this.$parent.showInventryGeneratorSideBar = false
    }
    return this.$emit('showOrHideMapCommentSideBar')
  },
  // Affiche le composant de génération d'entrées d'inventaires (émission de l'évènement au composant parent - SeadragonViewer)
  showInventryGeneratorSideBar: function(){
      if(this.$parent.showMapCommentSideBar) {
        this.$parent.showMapCommentSideBar = false
      }
    return this.$emit('showOrHideInventryGeneratorSideBar')
  }
}
}
</script>
<style>
#toolsViewerComponent {
  position: fixed;
  top: 56px;
  z-index: 1069;  /* car z-index des tools tips est 1070 */
  width: 100%;
  padding: 5px;
  background-color: #9F0303;
}

#tools, #contextualizedTitleSpan {
  font-style: italic;
  font-size: 14px;
}

#icons {
  color: white;
}

#toolbar {
  color: white;
  margin-left: 10px;
}

#searchInput {
  width: 20em;
  margin-right: 20px;
}

.spacer {
  flex: 1 1 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/commons/ToolsViewer.vue